// Before Safari 17.4, HTMLElement did not have a checkVisibility method.
import { browser } from '../global/browser';

if (
    browser.isBrowserRuntime() &&
    typeof HTMLElement.prototype.checkVisibility !== 'function'
) {
    HTMLElement.prototype.checkVisibility = function () {
        const style = browser.run(() => window.getComputedStyle(this));
        if (!style) {
            return false;
        }
        return (
            style.display !== 'none' &&
            style.visibility !== 'hidden' &&
            style.opacity !== '0' &&
            this.offsetParent !== null &&
            this.offsetWidth > 0 &&
            this.offsetHeight > 0
        );
    };
}

export {};
